exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center_buttons[data-v-6573a4e2]{text-align:center;}\n", ""]);

// exports
